<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>参赛码管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择赛区"
                style="width: 100%"
                v-model="queryForm.districtId"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
                clearable
              >
                <el-option
                  v-for="item in dict_matchType"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="formLevel">
              <el-select
                placeholder="请选择"
                v-model="queryForm.formLevel"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dict_Group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="参赛码" prop="matchCode">
              <el-input
                v-model="queryForm.matchCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">参赛码信息</span>
        </el-col>
        <el-col :span="15" style="text-align: right">
          <el-button type="primary" @click="newFn">新增参赛码</el-button>
        </el-col>
      </el-row>
      <div class="page-desc">个人赛参赛码（2022~2023赛季复赛表单答题解锁比赛使用）。</div>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column
          label="赛区"
          prop="districtId"
          :formatter="formatDistrict"
          width="220px"
        ></el-table-column>
        <el-table-column
          label="赛程"
          prop="raceSchedule"
          :formatter="formatSchedule"
        ></el-table-column>
        <el-table-column label="参赛码" prop="matchCode"></el-table-column>
        <el-table-column
          label="组别"
          prop="formLevel"
          :formatter="formatLevel"
        ></el-table-column>
        <el-table-column label="开始时间" prop="startTime"></el-table-column>
        <el-table-column label="结束时间" prop="endTime"></el-table-column>
        <el-table-column label="创建人" prop="creator"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="small"
              @click="editFn(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑信息的dialog -->
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="520px"
      @close="closeFn"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        ref="editInfoFormRef"
        :rules="editInfoRules"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="参赛码" prop="matchCode">
              <el-input
                :disabled="editType === 1"
                v-model="editForm.matchCode"
                placeholder="非必填，不填可由系统生成"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛季" prop="season">
              <el-select
                :disabled="editType === 1"
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="editForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                :disabled="editType === 1"
                placeholder="请选择赛区"
                style="width: 100%"
                v-model="editForm.districtId"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                :disabled="editType === 1"
                placeholder="请选择赛程"
                style="width: 100%"
                v-model="editForm.raceSchedule"
              >
                <el-option
                  v-for="item in dict_matchType"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="组别" prop="formLevel">
              <el-select
                :disabled="editType === 1"
                placeholder="请选择赛区"
                style="width: 100%"
                v-model="editForm.formLevel"
              >
                <el-option
                  v-for="item in dict_Group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="有效期" prop="startTime">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="dateChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryDistrictPage, queryFormMatchListPage, saveFormMatch } from '@/http/api'

export default {
  name: 'semi_final_form_code',
  data () {
    return {
      dict_district: [],
      dict_matchType: [],
      dict_season: [],
      dict_Group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        matchCode: '',
        formLevel: '',
        raceSchedule: ''
      },
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      title: '',
      visible: false,
      editForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        endTime: '',
        formLevel: '',
        matchCode: '',
        raceSchedule: '',
        startTime: ''
      },
      editInfoRules: {
        districtId: [{ required: true, message: '请选择', trigger: 'change' }],
        formLevel: [{ required: true, message: '请选择', trigger: 'change' }],
        raceSchedule: [{ required: true, message: '请选择', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择', trigger: 'change' }],
        season: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      dateRange: [],
      editType: ''
    }
  },
  created () {
    this.getSeason()
    this.getDistrictList()
    this.dict_matchType = this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => { this.dict_matchType = value })
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getSeason () {
      this.$userInfo.getDataList(this, 't_season').then(value => {
        this.dict_season = value
        // this.queryForm.season = value[0].dictValue
        this.getDataList()
      })
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getDataList () {
      queryFormMatchListPage({ ...this.queryForm, ...{ pageNum: this.pageIndex, pageSize: this.pageSize } }).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    search () {
      this.pageIndex = 1
      this.getDataList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      // this.queryForm.season = this.dict_season[0].dictValue
      this.search()
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getDataList()
    },
    handleCurrentChange (e) {
      this.pageIndex = e
      this.getDataList()
    },
    editFn (data) {
      this.visible = true
      this.title = '修改参赛码'
      this.editType = 1
      Object.keys(this.editForm).forEach(key => {
        // console.log(key, this.editForm[key], data[key])
        if (key === 'districtId' || key === 'raceSchedule' || key === 'formLevel') {
          this.editForm[key] = String(data[key])
        } else {
          this.editForm[key] = data[key]
        }
      })
      this.editForm.id = data.id
      this.dateRange[0] = new Date(this.editForm.startTime).getTime()
      this.dateRange[1] = new Date(this.editForm.endTime).getTime()

      // console.log(this.editForm, this.dateRange)
    },
    newFn () {
      this.visible = true
      this.title = '新增参赛码'
      this.editType = 0
      this.dateRange = []
      this.editForm = {
        districtId: '',
        endTime: '',
        formLevel: '',
        matchCode: '',
        raceSchedule: '',
        startTime: '',
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason
      }
      console.log(this.editForm)
    },
    closeFn () {
      this.visible = false
    },
    saveFn () {
      this.$refs.editInfoFormRef.validate(valid => {
        if (!valid) return
        console.log(this.editForm)
        this.editForm.districtName = this.dict_district.find(item => item.id === this.editForm.districtId).districtName
        const url = this.editType === 0 ? '/form/saveFormMatch' : '/form/updateFormMatch'
        saveFormMatch(url, this.editForm).then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.visible = false
            this.search()
            this.$refs.editInfoFormRef.resetFields()
          }
        })
      })
    },
    dateChange (e) {
      this.editForm.startTime = this.$moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      this.editForm.endTime = this.$moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    formatLevel (data) {
      // console.log(this.dict_Group)
      return this.dict_Group.find(item => Number(item.dictValue) === Number(data.formLevel)).dictLabel
    },
    formatDistrict (data) {
      return this.dict_district.find(item => Number(item.id) === Number(data.districtId)).districtName
    },
    formatSchedule (data) {
      return this.dict_matchType.find(item => Number(item.id) === Number(data.raceSchedule)).scheduleName
    }

  }
}
</script>
<style lang="less" scoped>
</style>
